import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { reportInventoryAge } from 'utils/breadcrumbInfo';
import reportsUtil from 'utils/reportsApi';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getInventoryAge, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getProductCategories, resetProductCategories } from 'actions/EntityActions';
import Grid from 'screens/components/basic/Grid';
import Pagination from 'screens/components/basic/Pagination';
import PageHeader from 'screens/components/basic/PageHeader';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class InventoryAge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false
        };
        this.showBody = this.showBody.bind(this);
        this.inventory = [];
    }

    getReport = () => {
        const model = {
            branch: this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch,
            productName: this.props.inventoryAgeProductName || '',
            categoryName: this.props.inventoryAgeCategoryName || '',
            brandName: this.props.inventoryAgeBrandName || '',
            pageNumber: this.state.activePage,
            isCannabis: this.props.isCannabis ? this.props.isCannabis : "2",
            category: this.props.categoryFilter || 0,
            pageSize: 20
        }
        this.props.getInventoryAge(model);
    }

    componentWillMount() {
        this.props.getProductCategories(this.props.branchId || parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')));
    }

    componentWillUnmount() {
        this.props.resetProductCategories();
    } 

    downloadInventory = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let pageNumber = 1;
        let pageSize = 9999;
        let productName = this.props.inventoryAgeProductName || '';
        let categoryName = this.props.inventoryAgeCategoryName || '';
        let brandName = this.props.inventoryAgeBrandName || '';
        let isCannabis = this.props.isCannabis || 0;
        let category = this.props.categoryFilter || 0;
        this.props.getCsvReport(`reports/excel/inventoryAge?branch=${branch}&productName=${productName}&categoryName=${categoryName}&brandName=${brandName}&pageNumber=${pageNumber}&pageSize=${pageSize}&isCannabis=${isCannabis}`, "inventoryAge");
    }

    getCategoryOptions = () => {
        return (this.props.category.list || []).map(item => {
            return {
                text: item.name,
                value: item.id.toString(),
                isCannabis: item.isCannabis
            };
        });
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    render() {
        const totalRow = this.props.inventoryAge? this.props.inventoryAge.length > 0 ? this.props.inventoryAge[0].totalrow : 0 : 0;
        return (
            <Grid headerContent={reportInventoryAge}>
                <PageHeader title={LOOKUP.report.inventoryAge.text}
                    description={LOOKUP.report.inventoryAge.description}
                />
                <Header
                    branchOptions={this.props.branchOptions}
                    filter={this.filter}
                    downloadInventory={this.downloadInventory}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                    isCannabis={this.props.isCannabis}
                    isCannabisOptions={this.props.isCannabisOptions}
                    productCategoriesOptions={this.props.productCategoriesOptions}
                />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body inventoryAge={this.props.inventoryAge} />
                        <Pagination
                            length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    });
    const isCannabisOptions = [
        {
            text: "All", value: "2"
        },
        {
            text: "Cannabis", value: "1"
        },
        {
            text: "Non-Cannabis", value: "0"
        }
    ];
    const productCategories = state.entity.productCategories.list || [];
    const productCategoriesOptions = [];
    productCategories.map((item) => {
        productCategoriesOptions.push({
            text: item.name, 
            value: item.name,
            isCannabis: item.isCannabis
        })
    })

    return {
        branchOptions: branchOptions,
        productCategories: state.entity.productCategories,
        categoryFilter: state.form.InventoryAgeCategoryOption,
        isCannabis: state.form.InventoryAgeIsCannabis,
        isCannabisOptions,
        productCategoriesOptions,
        inventoryAge: state.reports.inventoryAge,
        loggedBranch: state.common.branchId,
        branch: state.form.OrderListBranchOption,
        inventoryAgeProductName: state.form.InventoryAgeProductName,
        inventoryAgeCategoryName: state.form.InventoryAgeCategoryName,
        inventoryAgeBrandName: state.form.InventoryAgeBrandName,
        selectedBranch: state.form.InventoryAgeBranchOption
    };
};

const mapDispatchToProps = dispatch => {

    return {
        getInventoryAge: (model) => dispatch(getInventoryAge(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        resetProductCategories: () => dispatch(resetProductCategories()),
        getProductCategories: (branchId) => dispatch(getProductCategories(branchId)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryAge);